import Button from "@src/app/components/Button/Button";
import { createMetaTags } from "@src/app/components/MetaTags/MetaTags";

export const meta = () =>
  createMetaTags({
    title: "投稿 | 红蚂蚁",
    description:
      "​红蚂蚁编辑团队欢迎你踊跃投稿，一起和我们咬文嚼字，咬咬其他读者！《红蚂蚁》以生动的笔调撰写独立观点，以新颖的手法呈现新闻，让读者被咬得直呼过瘾。",
    canonical: "https://www.redants.sg/submission",
  });

export default function SubmissionPage() {
  return (
    <main className="bg-secondary py-[20px] lg:px-[24px]">
      <div className="m-auto box-border px-[12px] text-secondary xs:max-w-full lg:min-h-[calc(100vh-286px)] lg:max-w-[944px] xxl:max-w-[800px]">
        <h1 className="mb-[16px] text-header-1">投稿 Tab</h1>
        <p className="mb-[16px] text-body-1">
          红蚂蚁编辑团队欢迎你踊跃投稿，一起和我们咬新闻！我们非常乐意听取你对时下热门话题的独到见解与观点评论，一起尊重彼此可以有不同意見，一起相互学习。文章篇幅请控制在1200字以内。
        </p>
        <p className="mb-[16px] text-body-1">
          除了文字，如果你有配图或照片，也可以一并发给我们，格式为JPG，每张大小不宜超过1MB。请以附件方式添加在电邮并附上图片说明。
        </p>
        <p className="mb-[16px] text-body-1">
          投稿时别忘了附上你的真实姓名与职称以及手机号和通讯地址，方便我们联系，谢谢。
        </p>
        <Button
          className="my-[16px] px-[16px] py-[8px]"
          onClick={() => window.open("mailto:antseditorial@redants.sg")}
          type="button"
        >
          投稿
        </Button>
        <p className="mb-[16px] text-body-1">
          <span className="font-bold">温馨提醒</span>
          ：文章里若有从他处截取文字、图片、视频、音频或其他内容，应避免抄袭及侵犯版权。
        </p>
        {/* <p className="mb-[16px] text-body-1">
            红蚂蚁编辑团队欢迎你踊跃投稿，一起和我们咬文嚼字，咬咬其他读者！
          </p>
          <p className="mb-[16px] text-body-1">
            我们非常乐意听取你对时下热门话题的独到见解与观点评论，一起尊重彼此可以有不同意見，一起相互学习。
          </p>
          <p className="mb-[16px] text-body-1">
            除了文字以外，如果你有配图或照片，也可以发送给我们，格式为JPG，每张大小不宜超过1MB。请以附件方式添加在电邮并附上图片说明。
          </p>
          <p className="mb-[16px] text-body-1">
            文章篇幅请尽量控制在2000字以内。
          </p>
          <p className="mb-[16px] text-body-1">
            投稿时别忘了附上你的真实姓名与职称以及手机号和通讯地址，方便我们联系。如不介意
            “亮相”，也可以将个人近照发给我们。
          </p>
          <p className="mb-[16px] text-body-1">
            赶紧行动吧！我们已经擦亮触角磨好牙齿……等·着·你！
          </p>
          <Link
            to="mailto:antseditorial@redants.sg"
            className="text-body-1 text-link-primary underline hover:text-link-primary-hover"
          >
            antseditorial@redants.sg
          </Link>
           <Button
            className="my-[16px] px-[16px] py-[8px]"
            onClick={() => window.open("mailto:antseditorial@redants.sg")}
            type="button"
          >
            投稿
          </Button>
          <p className="mb-[16px] text-body-1">
            最后，想顺带提个醒，文章里若有从他处截取文字、图片、视频、音频或其他内容，应避免侵犯版权。
          </p> */}
      </div>
    </main>
  );
}
